module.exports = __webpack_public_path__ + "static/media/Gosch_Carola-055R-scaled.b24a191c.jpg";